import React from 'react';
import img1 from '../../../../assets/logos/head-logo.png';
import { Link } from 'react-router-dom';

const DashHeader = () => {
    return (
        <div>
            <div className="navbar bg-base-300">
                <label tabIndex={0} htmlFor="dashboard-drawer" className="btn btn-ghost  lg:drawer-open lg:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                </label>
                <div className="flex-1">
                    <Link to='/'><img src={img1} alt="" className='w-40' /></Link>
                </div>
                <div className="flex-none">
                    <div className="dropdown dropdown-end">
                        <div tabIndex={1} role="button" className="btn btn-ghost btn-circle avatar">
                            <div className="w-10 rounded-full">
                                <img alt="Tailwind CSS Navbar component" src="https://daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                            </div>
                        </div>
                        <ul tabIndex={2} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                            <li><Link to='/dashboard/profile'>View Profile</Link>
                            </li>
                            <li><Link to='/dashboard/setting'>Settings</Link></li>
                            <li><a>Logout</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashHeader;